import { useEffect } from 'react';
import type { FC } from 'react';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import {
  Avatar,
  Box,
  Divider,
  Drawer,
  Hidden,
  Typography,
} from '@material-ui/core';
import { connect } from 'react-redux';
import DataMenuCompraDeuda from 'src/utils/data/DataMenuCompraDeuda';
import GaugeIcon from '../icons/Gauge';
import FolderIcon from '../icons/FolderOpen';
import NavSection from './NavSection';
import Scrollbar from './Scrollbar';
import DataMenuReports from '../../utils/data/DataMenuReport';
import {
  MENU_ADMIN,
  MENU_COMPRADEUDA,
  MENU_DASHBOARD,
  ROLE_ADMIN,
  ROLE_DASHBOARD,
  VIEW_COMPRADEUDA,
  VIEW_FUVEX,
} from '../../utils/constants';

interface DashboardSidebarProps {
  onMobileClose: () => void;
  openMobile: boolean;
  user?: any;
}

const sections = [
  {
    id: MENU_COMPRADEUDA,
    title: MENU_COMPRADEUDA,
    items: [
      ...DataMenuCompraDeuda.map(({ title, path, Icon, id }) => ({
        title,
        path,
        icon: <Icon fontSize="small" />,
        id,
      })),
    ],
  },
  {
    id: MENU_DASHBOARD,
    title: MENU_DASHBOARD,
    items: [
      ...DataMenuReports.map(({ title, path, Icon, id }) => ({
        title,
        path,
        icon: <Icon fontSize="small" />,
        id,
      })),
    ],
  },
  {
    id: MENU_ADMIN,
    title: MENU_ADMIN,
    items: [
      {
        id: 90,
        title: 'Carga de Datos',
        path: '/admin/upload',
        icon: <FolderIcon fontSize="small" />,
      },
      {
        id: 91,
        title: 'Semaforización',
        path: '/admin/gauge',
        icon: <GaugeIcon fontSize="small" />,
      },
    ],
  },
];

const DashboardSidebar: FC<DashboardSidebarProps> = (props) => {
  const { onMobileClose, openMobile, user } = props;
  const location = useLocation();

  useEffect(() => {
    if (openMobile && onMobileClose) {
      onMobileClose();
    }
  }, [location.pathname]);

  const content = (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
      }}
    >
      <Scrollbar options={{ suppressScrollX: true }}>
        <Hidden lgUp>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              p: 2,
            }}
          >
            <img src="/static/images/kontigo.png" alt="logo" />
          </Box>
        </Hidden>
        <Box sx={{ p: 2 }}>
          <Box
            sx={{
              alignItems: 'center',
              backgroundColor: 'background.default',
              borderRadius: 1,
              display: 'flex',
              overflow: 'hidden',
              p: 2,
            }}
          >
            <RouterLink to="/admin">
              <Avatar
                sx={{
                  cursor: 'pointer',
                  height: 48,
                  width: 48,
                }}
              />
            </RouterLink>
            <Box sx={{ ml: 2 }}>
              <Typography color="textPrimary" variant="subtitle2">
                {user?.name}
              </Typography>
              <Typography color="textSecondary" variant="body2">
                {user?.role?.name}
              </Typography>
            </Box>
          </Box>
        </Box>
        <Divider />
        <Box sx={{ p: 2 }}>
          {sections.map((section, index) => {
            if (
              ((section.title === MENU_COMPRADEUDA
                && user.role.name === ROLE_DASHBOARD)
              || (section.title === MENU_ADMIN && user.role.name === ROLE_ADMIN)) && (user.abilities.includes(VIEW_COMPRADEUDA) || (!user.abilities.includes(VIEW_COMPRADEUDA) && !user.abilities.includes(VIEW_FUVEX)))
            ) {
              return (
                <NavSection
                  key={section.title}
                  pathname={location.pathname}
                  sx={{
                    '& + &': {
                      mt: 3,
                    },
                  }}
                  {...section}
                />
              );
            }
            if (
              ((section.title === MENU_DASHBOARD
                && user.role.name === ROLE_DASHBOARD)
              || (section.title === MENU_ADMIN && user.role.name === ROLE_ADMIN)) && (user.abilities.includes(VIEW_FUVEX) || (!user.abilities.includes(VIEW_COMPRADEUDA) && !user.abilities.includes(VIEW_FUVEX)))
            ) {
              return (
                <NavSection
                  key={section.title}
                  pathname={location.pathname}
                  sx={{
                    '& + &': {
                      mt: 1,
                    },
                  }}
                  {...section}
                />
              );
            }
            const key = `noSection-${index}`;
            return <div key={key} />;
          })}
        </Box>
        <Divider />
      </Scrollbar>
    </Box>
  );

  return (
    <>
      <Hidden lgUp>
        <Drawer
          anchor="left"
          onClose={onMobileClose}
          open={openMobile}
          PaperProps={{
            sx: {
              backgroundColor: 'background.paper',
              width: 280,
            },
          }}
          variant="temporary"
        >
          {content}
        </Drawer>
      </Hidden>
      <Hidden lgDown>
        <Drawer
          anchor="left"
          open
          PaperProps={{
            sx: {
              backgroundColor: 'background.paper',
              height: 'calc(100% - 64px) !important',
              top: '64px !Important',
              width: 280,
            },
          }}
          variant="persistent"
        >
          {content}
        </Drawer>
      </Hidden>
    </>
  );
};

const stateToProps = (state) => ({
  user: state.auth.user,
});

export default connect(stateToProps, {})(DashboardSidebar);
